<div class="footer">
  <div id="footer__mobile-menu">
    <button ttButton variant="secondary" (click)="handleMobileMenuClick()">
      <mat-icon [icon]="'menu'" [iconSize]="16" />
      @if (isMenuOpen()) {
        <span>{{ 'Close' | transloco }}</span>
      } @else {
        <span>{{ 'Content' | transloco }}</span>
      }
    </button>
  </div>
  <div class="flex-area left">
    <ng-content select="[leftArea]" />
  </div>
  <div class="flex-area center">
    <ng-content select="[centerArea]" />
  </div>
  <div class="flex-area right">
    <ng-content select="[rightArea]" />
  </div>
</div>
